<template>
    <fragment>
        <div image-fill class="container section-inner illustration-section-01">
            <h1>联系我们</h1>
            <div>
                <div style="float:left">
                    <img width="100" height="100" :src="require('@/assets/images/wechat.png')"/>
                </div>
                <div style="float:left;margin-left:20px;">
                    <h2>+8613986837403</h2>
                </div>
                <br>
                <div style="float:left">
                    <img width="100" height="100" :src="require('@/assets/images/whatsapp.png')"/>
                </div>
                <div style="float:left;margin-left:20px;">
                    <h2>+61426188363(新马台or邮局专线)</h2>
                </div>

                <div style="float:right">
                    <img width="150" height="150" :src="require('@/assets/images/QRCode.png')"/>
                </div>
            </div>
        </div>
        <c-team style="clear:both"/>
        <div image-fill class="container section-inner illustration-section-01">
            <div style="float:left;width:420px;">
                <p>Line-1 International Express—号线国际速递</p>
                <p>地址:Unit 2, 11 Ferguson St, Kewdale WA 6105</p>
                <p>电话:N/A</p>
                <p>电邮: info@line-1.com.au</p>
                <p>专职售后客服微信/联系电话:+8613986837403</p>
                <p>营业时间:Kewdale仓库不对外营业，零售业务请前往门店办理直营店</p>
                <p>营业时间:周一至周五10: 00-20: O0;周六周日10: 00-17: 0o</p>
            </div>
            <iframe width="600" height="450" frameborder="0" style="border:0;float:right" src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJnQbOqfS9MioR4zywt5ERACI&key=AIzaSyA81B2T5xZbmk1hYQyKj4rTIBJLiVlIhIk" allowfullscreen></iframe>
        </div>
        <c-cta top-divider bottom-divider split style="clear:both"/>
    </fragment>
</template>

<script>
// import layout
import CLayout from '@/layouts/LayoutDefault.vue'
import CTeam from '@/components/sections/Team.vue'
import CCta from '@/components/sections/Cta.vue'

export default {
  name: 'Secondary',
  components: {
    CTeam,
    CCta,
  },
  data() {
    return {
    }
  },
  created() {
    this.$emit('update:layout', CLayout)
  }
}
</script>
